import { Component, OnInit, Input } from '@angular/core';
import { NewsConfigurations } from './news.configurations';
import { KlaHttpService } from '../services/kla.http.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'kla-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss', '../../../app.component.scss'],
  standalone: true,
  imports: [ CommonModule ]
})
export class NewsComponent implements OnInit {

  @Input()
  public config: NewsConfigurations;

  public imagePath: string;

  constructor(private httpService: KlaHttpService) { }

  ngOnInit() {
    if (!this.config) {
      this.config = <NewsConfigurations>{};
    }
    this.imagePath = this.httpService.getImagePath(this.config.image, 200);
  }

  visitNewsSource(link) {
    if (!link) {
      return;
    }
    window.open(link, '_blank');
  }
}
